import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import CustomhtmlForFeature from 'utils/CustomDefault';

export const BROWARDPARCEL_LAYER_ID = 'browardParcelLayer';

export const CATEGORY_COLORS = {
  Parcel: [0, 100, 214],
};

const layerConfig = {
  title: 'Parcels',
};

function BrowardParcelLayer() {
  const dispatch = useDispatch();
  const { browardParcelLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, browardParcelLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (browardParcelLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: BROWARDPARCEL_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: browardParcelLayer.visible,
      opacity: browardParcelLayer.opacity,
      getFillColor: [0, 100, 214],
      pointRadiusMinPixels: 3,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: BROWARDPARCEL_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: CustomhtmlForFeature({
              feature: info.object,
              title: 'Parcel Details',
              includeColumns: [
                'City',
                'Zip_Code',
                'Use_Code',
                'Use_Code_Description',
                'Just_Total_Value',
                'Land_Area_Square_Feet',
              ],
            }),
          };
        }
      },
    });
  }
}

export default BrowardParcelLayer;
